// extracted by mini-css-extract-plugin
module.exports = {"CommentListPlaceholder":"ie_a bhc_je","CommentListPlaceholder--Legacy":"ie_b bhc_qh bhc_vk"};